import React from 'react';

import './Retry.component.css';

export default class Retry extends React.Component {
    render() {
        return (
            <div className="retry-container">
                Server Busy.  Please try again in a few minutes or reply via email.
            </div>
        );
    }
}